import { CollectionInfo } from '../models/collection';

export const MockCollection = (id: number): CollectionInfo => ({
  id,
  title: `Collection ${id}`,
  description: `Collection ${id} description placeholder`,
  start_date: '2022-10-24T11:10:55.000Z',
  end_date: null,
  hero_image:
    'https://images.ctfassets.net/63zu1jme7dht/EjHwoJREZ5iATVDXt0fG3/91730cffffaf341d69e4f5726c83d69e/Fashion_icons_Louis_Vuitton_collection.jpg',
  categories: [313, 721],
  url: 'https://www.catawiki.com/en/x/815-fashion-icons-louis-vuitton-collection',
  color: '#919397',
  title_color: '#919397',
  cta_text: 'Discover all 719 objects',
  campaign_dates: null,
  images: [
    {
      url: 'https://assets.catawiki.nl/assets/2022/11/4/5/c/e/5ce6e5b6-2aea-4401-baac-b408e8507158.jpg',
      orientation: 'portrait',
    },
    {
      url: 'https://assets.catawiki.nl/assets/2022/10/19/b/5/6/b565427f-a7f5-4f62-9972-afcfb6fa0286.jpg',
      orientation: 'portrait',
    },
    {
      url: 'https://assets.catawiki.nl/assets/2022/10/27/d/7/0/d70b05af-d8b5-468b-af9f-571d480f2240.jpg',
      orientation: 'portrait',
    },
    {
      url: 'https://assets.catawiki.nl/assets/2022/10/11/a/0/1/a013e2c8-d420-4280-80f0-8354f9ff8976.jpg',
      orientation: 'landscape',
    },
    {
      url: 'https://assets.catawiki.nl/assets/2022/11/3/5/3/a/53a7d23b-5fbc-41fd-a779-649728242768.jpg',
      orientation: 'landscape',
    },
  ],
  lot_count: 719,
  tags: 'FASHION • BAGS • FASHION ACCESSORIES',
});
